import VetList from '../../views/Vet/VetList';
import VetCustomerList from '../../views/VetCustomer/VetCustomerList';

export default [
    {
        path: '/veterinarios',
        name: 'vet.list',
        component: VetList,
        meta: {
            pageTitle: 'Veterinários',
            breadcrumb: [
                { label: 'Veterinários' },
            ],
        },
    },
    {
        path: '/veterinarios/clientes',
        name: 'vet-customer.list',
        component: VetCustomerList,
        meta: {
            pageTitle: 'Clientes',
            breadcrumb: [
                { label: 'Clientes' },
            ],
        },
    }
];
